module.exports = __webpack_public_path__ + "static/media/areas05.d393a20a.jpg";